<template>
   <div class="pd-10">
     <div class="alert alert-outline alert-info" v-if="!hasLines">
       No fees of this type so far.  Consider yourself lucky.
     </div>
     <table class="table" v-if="hasLines">
       <thead>
         <tr>
           <th scope="col">Card Brand</th>
           <th scope="col">Fee</th>
           <th scope="col" class="text-right">Volume</th>
           <th scope="col" class="text-right">TX Count</th>
           <th scope="col" class="text-right">Fee %</th>
           <th scope="col" class="text-right">Per TX</th>
           <th scope="col" class="text-right">Published Total</th>
           <th scope="col" class="text-right">Statement Total</th>
           <th scope="col"></th>
         </tr>
       </thead>
       <tbody>
         <edit-line-item @deleteLineItem="handleLineItemDelete" @updateLineItem="handleLineItemUpdate" :lineItem="line" v-for="line in lineItems.lineItems" v-bind:key="line.id"/>
       </tbody>
     </table>
  </div>
</template>


<script>
import EditStatementLineItem from '@/components/EditStatementLineItem'

export default {
  name: 'line-item-table',
  props: ['id', 'categories', 'lineItems'],
  components: {
    'edit-line-item': EditStatementLineItem
  },
  computed: {
    hasLines: function () {
      return this.lineItems && this.lineItems.lineItems && this.lineItems.lineItems.length > 0
    }
  },
  methods: {
    handleLineItemDelete: function (e) {
      this.$emit("deleteLineItem", e)
    },
    handleLineItemUpdate: function (e) {
      this.$emit("updateLineItem", e)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
